import { createPortal } from "react-dom"
import classnames from "classnames"

import Modal from "shared/components/modal"
import XIcon from "shared/components/icons/x_icon"

import styles from "./currency_switcher.module.scss"

export interface Currency {
  code: string
  symbol: string
}

// Codes arrive lowercase from the backend (e.g. "usd"); show them as "USD - $".
export const currencyLabel = ({ code, symbol }: Currency) => `${code.toUpperCase()} - ${symbol}`

interface Props {
  show: boolean
  currencies: Currency[]
  selectedCode: string
  onSelect: (code: string) => void
  onClose: () => void
}

// Portaled to <body> so styles of a host checkout modal (e.g. `.checkout-on-modal .modal-content`) don't leak in.
export default function CurrencySwitcherModal({ show, currencies, selectedCode, onSelect, onClose }: Props) {
  return createPortal(
    <Modal show={show} closeListener={onClose} includeCloseX={false} leftJustifyHeader>
      <div className={styles.modal}>
        <div className={styles.header}>
          <p className={styles.title}>Switch currency</p>
          <button type="button" className={styles.close} aria-label="Close" onClick={onClose}>
            <XIcon width="18" height="18" />
          </button>
        </div>
        <ul className={styles.list}>
          {currencies.map(currency => (
            <li key={currency.code}>
              <button
                type="button"
                className={classnames(styles.option, {
                  [styles.selected]: currency.code === selectedCode,
                })}
                onClick={() => onSelect(currency.code)}
              >
                {currencyLabel(currency)}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </Modal>,
    document.body,
  )
}
